import type { RecommendationItem } from './types'

export const DEFAULT_BASELINE_EPOCH_AT = '2026-01-01T00:00:00.000Z'

export const INITIAL_PLAN_CONFIG = {
  targetDate: null as string | null,
  weeklyCommitmentHours: 0,
}

export const INITIAL_COMPLETED_WORK = []

export const INITIAL_CALCULATION_LOG = []

export const INITIAL_RECOMMENDATIONS: RecommendationItem[] = []
